import React from "react";
import { Box } from "@dxp-feed/ui/Box";
import { Button } from "@dxp-feed/ui/Button";

export default function MobileSortable({
  toggleCategory,
  toggleSort,
  isSearchPage,
  heading,
  selectedCategory
}: {
  toggleCategory: () => void;
  toggleSort: () => void;
  isSearchPage?: boolean;
  heading: string;
  selectedCategory: string | null;
}) {
  return (
    <Box
      as="div"
      className="bg-grey100 filter-mobile lg:bg-transparent lg:hidden flex flex-col 2xs:flex-row w-full py-4 gap-2 mb-6 order-1 md:order-2 md:justify-start relative before:content-[''] before:absolute after:content-[''] after:absolute before:block after:block before:h-full after:h-full before:bg-grey100 after:bg-grey100 before:w-6 after:w-6 before:left-[-24px] after:right-[-24px]  before:top-0  after:top-0 lg:before:content-none lg:after:content-none 2md:before:w-12 2md:after:w-12 2md:before:left-[-48px] 2md:after:right-[-48px]"
    >
      <Button
        variant="outlneWhite"
        onClick={toggleCategory}
        aria-label="All Category"
        className="w-full md:w-auto border bg-brandWhite border-grey350 font-light text-[14px] gap-2"
      >
        <span className="demo-icon icon-filter w-[18px] h-[18px] text-[11px] flex items-center justify-center  text-black900"></span>
        {`${selectedCategory ? selectedCategory: 'All Category'}`}
      </Button>
      <Button
        variant="outlneWhite"
        onClick={toggleSort}
        aria-label="sort order"
        className="w-full md:w-auto border bg-brandWhite border-grey350 font-light text-[14px] gap-2"
      >
        <span className="demo-icon icon-swap w-[18px] h-[18px] text-[18px] flex items-center justify-center text-black900"></span>
        {heading}
        {""}
      </Button>
    </Box>
  );
}
